"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var _JobDispatchDetailViewDispatch2 = _interopRequireDefault(require("./__generated__/JobDispatchDetailViewDispatch.graphql"));
var React = _interopRequireWildcard(require("react"));
var _reactRelay = require("react-relay");
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _DetailGrid = _interopRequireDefault(require("web/shared/jobs/DetailGrid"));
var _JobLogView = _interopRequireDefault(require("web/shared/jobs/JobLogView"));
var _JobRunsTable = _interopRequireDefault(require("web/shared/jobs/JobRunsTable"));
var _instants = require("web/shared/jobs/instants.js");
var _runStates = require("web/shared/jobs/runStates.js");
var _jobsViewsStyles = require("web/shared/jobs/jobsViews.styles.js");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
* One invocation of the dispatcher: what it ran, and what it logged.
*
* The suspending half of its page: it reads on render, so the loading and the
* failure lines belong to the frame above rather than to state here. A null
* answer is an ordinary one — a stale link reaches this page — and is said
* here rather than raised.
*/ // Runs and dispatches are fetched by their display number, which is what the
// operator sees everywhere and what the console's urls carry.
const DOCUMENT = _JobDispatchDetailViewDispatch2.default; /**
                                                          * One dispatch by its display number, with the runs it kicked off and its own
                                                          * log. Null when this product has no such dispatch — an ordinary answer
                                                          * rather than a failure, so the document leaves the field nullable and the
                                                          * page says what it shows instead.
                                                          */ /** Everything recorded about the invocation, in the order it is asked about. */
function detailRows(dispatch) {
  var _dispatch$slotTime, _dispatch$succeeded, _dispatch$failed, _dispatch$skipped, _dispatch$aborted;
  return [{
    label: "State",
    value: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_jobsViewsStyles.styles.pill, (0, _runStates.runStateStyle)(dispatch.state))), {}, {
      children: dispatch.state.toLowerCase()
    }))
  }, {
    label: "Trigger",
    value: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_jobsViewsStyles.styles.pill, _jobsViewsStyles.styles.pillMuted)), {}, {
      children: dispatch.trigger.toLowerCase()
    }))
  }, {
    label: "Slot",
    value: (_dispatch$slotTime = dispatch.slotTime) !== null && _dispatch$slotTime !== void 0 ? _dispatch$slotTime : "—"
  }, {
    label: "Date",
    value: (0, _instants.formatDate)(dispatch.startedAt)
  }, {
    label: "Started",
    value: (0, _instants.formatTime)(dispatch.startedAt)
  }, {
    label: "Ended",
    value: (0, _instants.formatTime)(dispatch.finishedAt)
  }, {
    label: "Duration",
    value: (0, _instants.formatDuration)(dispatch.startedAt, dispatch.finishedAt)
  }, {
    label: "Jobs",
    value: dispatch.totalJobs == null ? "—" : String(dispatch.totalJobs)
  }, {
    label: "Outcome",
    value: "".concat(String((_dispatch$succeeded = dispatch.succeeded) !== null && _dispatch$succeeded !== void 0 ? _dispatch$succeeded : 0), " ok, ") + "".concat(String((_dispatch$failed = dispatch.failed) !== null && _dispatch$failed !== void 0 ? _dispatch$failed : 0), " failed, ") + "".concat(String((_dispatch$skipped = dispatch.skipped) !== null && _dispatch$skipped !== void 0 ? _dispatch$skipped : 0), " skipped, ") + "".concat(String((_dispatch$aborted = dispatch.aborted) !== null && _dispatch$aborted !== void 0 ? _dispatch$aborted : 0), " aborted")
  }, {
    label: "OS process",
    value: dispatch.osProcessPid == null ? "—" : String(dispatch.osProcessPid)
  }, {
    label: "DB backend",
    value: dispatch.dbBackendPid == null ? "—" : String(dispatch.dbBackendPid)
  }, {
    label: "Dispatch id",
    value: dispatch.dispatchId
  }];
}
function JobDispatchDetailView(props) {
  const data = (0, _reactRelay.useLazyLoadQuery)(DOCUMENT, {
    dispatchNumber: props.number
  }, {
    fetchKey: props.reloadKey,
    fetchPolicy: "network-only"
  });
  const detail = data.internalJobDispatch;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: detail == null ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_jobsViewsStyles.styles.statusNeutral)), {}, {
      children: ["No dispatch #", props.label, " for this product."]
    })) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_DetailGrid.default, {
        rows: detailRows(detail.dispatch)
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("h2", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_jobsViewsStyles.styles.subHeading)), {}, {
        children: "runs"
      })), /*#__PURE__*/(0, _jsxRuntime.jsx)(_JobRunsTable.default, {
        runs: detail.runs,
        showJob: true,
        emptyMessage: "This dispatch kicked off no runs."
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("h2", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_jobsViewsStyles.styles.subHeading)), {}, {
        children: "dispatcher log"
      })), /*#__PURE__*/(0, _jsxRuntime.jsx)(_JobLogView.default, {
        logs: detail.logs,
        emptyMessage: "This dispatch recorded no log lines."
      })]
    })
  });
}
var _default = exports.default = JobDispatchDetailView;